export default [
  {
    
    redirect : "/product/nexusdynamics",
    category : "Admin Panel",
    engine : "Roblox",
    price : "FREE",

    name : "Nexus Dynamics",
  
    overview : [
      "**✨ Nexus Dynamics** is a sophisticated admin panel designed for Roblox developers to manage and moderate their games efficiently. It offers a wide range of features and tools to enhance the control and customization of your Roblox experiences.",
      "",
      "Execute private commands with auto-fill suggestions with over 200 unique commands.",
      "",
      "Run `/setup` to install Nexus Dynamics, used to rank people instead of adding Ids in a script.",
      // "Edit terrain and sun position in-game, similar to Roblox Studio",
      "",
      "Nexus Dynamics is designed to provide developers with a powerful and user-friendly interface to manage their Roblox games, ensuring a smooth and enjoyable experience for both developers and players.",
      "#### ",
      "**How to install Nexus Dynamics - [Learn More](https://devequip.com/docs/nexusdynamics/installation)**",
      "# ", "# ",
      "## Features",
      "**Customizable Commands**",
      "",
      "Use the custom commands module to create your own commands precicely how Nexus Dynamics made theirs. You're able to use our API to integrate your command into our system to alter it's behavior.",
      "## ",
      "**Game Manager**",
      "",
      "Change how the game looks and behaves by altering the properties of services commonly found in studio explorer. You can change the gravity, skybox, and sound reverb!",
      "## ",
      //"**Studio-Like Editors**",
      //"",
      //"Use our editors to change the world without the need of studio. Using sun editor, you can place the sun at your mouse. Terrain editor can be used to alter how the terrain looks around you.",
      "## ",
      "**CommandBar with Auto Fill Suggestions**",
      "",
      "Write private commands in a command bar for a private and fully automated experience.",	
      "# ", "# ",
      "## Compatability",
      "[TopbarPlus v3.0.0](https://1foreverhd.github.io/TopbarPlus/) by ForeverHD",
      "",
      "[Roblox Ban API](https://devforum.roblox.com/t/introducing-the-ban-api-and-alt-account-detection/3039740) including IP bans"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),

    contributors : [
      {
        name : "@mark80912",
        deed : "Testing prototypes and quality assurance."
      },

      {
        name : "@zeyan200_gotdeleted",
        deed : "Ensuring quality during beta versions."
      },

      {
        name : "@bluebxrrybot",
        deed : "Assisting with a better alternative for noclip physics."
      },

      {
        name : "@THEDRAGONSMINIL",
        deed : "Designing themes during UGC Theme event.",
      }
    ],

    requirements: [
      "Http Request",
      "API Services",
      "Third Party Teleports",
      "Third Party Sales"
    ],
    

    logo : "/imgs/nd/logo.jpg", 
    thumbnails : [
      "/imgs/nd/t1.png",
      "/imgs/nd/t2.png",
      "/imgs/nd/t3.png",
      "/imgs/nd/t4.png",
      "/imgs/nd/t5.png"
    ],
    

    rating : 4.3,
    

    licenses : [
      {
        name : "Design",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      },
      {
        name : "Source-Code",
        type : "MIT License",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/LICENSE"
      }
    ],
    

    downloadcount : 47325,
    DISABLED_source : "https://github.com/donkingfrog",
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/116788591431002/Nexus-Dynamics-20"
      },

      {
        name : "RBXM",
        type : "File",
        href : "/download/nexusdynamics.rbxm"
      }
    ],
    

    version : "2.0.6",
    created : "Oct 16 2024",
    updated : "May 9 2025",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/donationboard",
    category : "Donation Board",
    engine : "Roblox",
    price : "FREE",

    name : "Donation Board",
    
    overview : [
      "**✨ Donation Board** is a system designed with the vision of simplicity and meant for monitization. It offers a large sum of features for setting up the donation board hastle free, whilst also bringing features for players to enjoy where-ever.",
      "## ",
      "Simulate after-tax donations or sort the board based of amount for ease of accounting.",
      "## ",
      "Adjustable settings provided in Roblox-Studio on the board during play-test to make the board complete your game!",
      "## ",
      "Celebrate with editable celebratory messages after each donation. **{player} = username / {robux} = amount**",
      "## ",
      "Go through all your developer products and enable/disable them without memorizing the ID. This can be found by play-testing in studio and pressing **Developer Products** under the donate page.",
      "",
      "# ", "# ",
      "## Features",
      "",
      "**Customizable Board**",
      "",
      "Revamp the board using only built-in UI such as animations, colors, and behaviors.",
      "## ",
      "**Simple Developer Products**",
      "",
      "Instead of writing IDs within a script, enable them with checkboxes on the board itself by play-testing in Roblox Studio and pressing Donate ➡ Developer Products"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),

    contributors : [
      {
        name : "@mark80912",
        deed : "Testing prototypes and quality assurance."
      },

      {
        name : "@zeyan200_gotdeleted",
        deed : "Testing in early alpha phases."
      }
    ],

    requirements: [
      "API Services"
    ],
    

    logo : "/imgs/db/logo.png", 
    thumbnails : [
      "/imgs/db/t1.jpg",
      "/imgs/db/t2.png"
    ],
    

    rating : 4.7,
    

    licenses : [
      {
        name : "Design",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      },
      {
        name : "Source-Code",
        type : "MIT License",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/LICENSE"
      }
    ],
    

    downloadcount : 52104,
    source : "https://github.com/donkingfrog",
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/17677778124/Donation-Board-30"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=116788591431002"
      }
    ],
    

    version : "3.2",
    created : "June 1 2024",
    updated : "Jan 4 2025",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/compass",
    category : "User Interface",
    engine : "Roblox",
    price : "FREE",

    name : "Compass",
  
    overview : [
      "**Compass**, implement a fully customizable compass mechanic within your game. Especially handy for players to regroup or find specific locations on non-procedural maps.",
      "## ",
      "The code must be placed within a `LocalScript` located in `StarterGui` or `StarterPlayerScripts`",
      "# ", "# ",
      "## Features",
      "**Generated Interface**",
      "",
      "The script generates the UI only leaving you with the script itself!",
      "## ", "## ",
      "**Border Mode**",
      "",
      "Enable a black background incase your game has bright lights that may blend with the text.",
      "## ", "## ",
      "**Analog Mode**",
      "",
      "Remove all numbers from being displayed on the compass except letters.",
      "## ", "## ",
      "**Indicator**",
      "",
      "Display the exact degree you're looking at.",
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/scripts/compasst1.jpg", 
    thumbnails : [
      "/imgs/scripts/compasst1.jpg",
      "/imgs/scripts/compasst2.jpg",
      "/imgs/scripts/compasst3.jpg",
    ],
    

    rating : 5,
    

    licenses : [
      {
        name : "Source-Code",
        type : "MIT License",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/LICENSE"
      }
    ],
    

    downloadcount : 148,
    source : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/compass.lua",
    downloads : [
      {
        name : "RBXM",
        type : "Link",
        href : "/download/compass.rbxm"
      },

      {
        name : "GitHub",
        type : "File",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/compass.lua"
      }
    ],
    

    version : "1.0.0",
    created : "March 10 2025",
    updated : "March 10 2025",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/basicobbykit",
    category : "Script",
    engine : "Roblox",
    price : "FREE",

    name : "Basic Obby Kit",
  
    overview : [
      "**🎈 Basic Obby Kit**, create fantastic obbies with our easy to use kit of basic parts any obby needs. Utilizing naming conventions and the tag feature, you can create an obby without programming anything!",
      "# ",
      "**You may delete the billboard, textures, and customize the part properties.**",
      "Don't touch the tags if you don't know what your doing.",
      "# ", "# ",
      "## Features",
      "",
      "**Checkpoints**",
      "",
      "Using Checkpoints you can create a progressive saving system by naming each accordingly: `Checkpoint[1]`, `Checkpoint[2]`, `Checkpoint[3]`.\n\nYou may hide the leaderstats by replacing `true` with `false` it in the Handler script.",
      "## ", "## ",
      "**Conveyor**",
      "",
      "You may adjust the speed of a conveyor by naming it according to the speed. `Conveyor[1]` <- Speed is at 1",
      "## ", "## ",
      "**Speed / Jump / Damage Pads**",
      "",
      "We provide pads that set the Speed/JumpHeight of a player or deal damage with names similar to the conveyor, write the speed/height/damage in brackets: `Speed[32]` | `Jump[14.4]` | `Damage[50]`",
      "## ", "## ",
      "**Heal / Kill / Respawn Pads**",
      "",
      "Upon touching the heal pad, the player's health will restored to 100%. Additionally, the kill will set their health to 0. The respawn pad is an alternative to kill in which it respawns the player immediately.",
      "## ", "## ",
      "**Fade**",
      "",
      "Touching these will have a 1 second transition between ghost mode where the part disappears. Using the settings found in the Handler script you may change the cooldown.",

    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),

    contributors : [
      {
        name : "@SupremeFlamey",
        deed : "Providing the textures."
      },
    ],

    requirements: [
      "API Services",
    ],
    

    logo : "/imgs/scripts/obbykitt1.jpg", 
    thumbnails : [
      "/imgs/scripts/obbykitt1.jpg"
    ],
    

    rating : 5,
    

    licenses : [
      {
        name : "Source-Code",
        type : "MIT License",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/LICENSE"
      }
    ],
    

    downloadcount : 311,
    source : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/basic-obby-kit.lua",
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/110082764617981/Basic-Obby-Kit"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=110082764617981"
      },

      {
        name : "GitHub",
        type : "File",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/basic-obby-kit.lua"
      }
    ],
    

    version : "1.0.0",
    created : "March 8 2025",
    updated : "March 8 2025",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/maid",
    category : "Script",
    engine : "Roblox",
    price : "FREE",


    name : "Maid",
    
    overview : [
      "**Maid**, a framework developed to clean memory and prevent memory leaks, flood of resources and maintaining a healthy server. This module's nature makes it essential for major frameworks or systems using RBXScriptSignals, threads, and more.",
      "# ", "# ",
      "# Features",
      "**Six Supported Task**",
      "",
      "This framework supports six different task types that can be given/cleaned:  RBXScriptSignal, Thread, Instance, Function, UserData, { Destroy or Cancel function }",
      "",
      "**Selective Cleaning By Type**",
      "",
      "You're able to ```Maid:DoCleaning()``` for all or ```Maid:DoCleaningByType(typeof)``` of selective cleaning.",
      "# ", "# ",
      "# Documentation",
      "This module can be used on the `Server` and `Client`, we recommend placing it in ReplicatedStorage.",
      "[Read Documentation](/docs/frameworks/maid/)",
      "#### ", "#### ",
      "Here's a quick example of a health monitor, which uses the maid to disconnect all the RBXScriptConnections when a player's character respawns.",
      "```",
      "local Maid = require('path/to/module')",
      "Maid = Maid.new()",
      "",
      "function CharacterAdded(character)",
      "   Maid:DoCleaning() -- Ensures previous RBXScriptSignal is disconnected",
      " ",
      "   Maid:GiveTask(character.Humanoid.GetPropertyChangedSignal('Health'):Connect(function()",
      "     print(character.Humanoid.Health)",
      "   end)",
      "end",
      "",
      "Players.PlayerAdded:Connect(function(player)",
      "   player.CharacterAdded:Connect(function(character)",
      "       CharacterAdded(character)",
      "   end)",
      "end)",
      "```",
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),

    logo : "/imgs/scripts/maidt1.jpg", 
    thumbnails : [
      "/imgs/scripts/maidt1.jpg"
    ],
    

    rating : 5,
    
    licenses : [
      {
        name : "Source-Code",
        type : "MIT License",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/LICENSE"
      }
    ],

    downloadcount : 58,
    source : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/maid.lua",
    downloads : [
      {
        name : "Lua",
        type : "Link",
        href : "/download/maid.lua"
      },

      {
        name : "GitHub",
        type : "File",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/maid.lua"
      },
    ],
    

    version : "1.0",
    created : "March 4 2025",
    updated : "March 4 2025",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/promise",
    category : "Script",
    engine : "Roblox",
    price : "FREE",

    name : "Promise",
    
    overview : [
      "**Promise**, a framework developed to recreate `Promises` from JavaScript. This framework helps with smoother error handling by allowing you to define what should happen when an operation succeeds (fulfilled) or fails (rejected).",
      "# ", "# ",
      "# Features",
      "**State Management**",
      "",
      "`Pending` : The promise is still pending and has not been fulfilled or rejected.\n",
      "`Fulfilled` : The promise has been resolved successfully.\n",
      "`Rejected` : The promise has been rejected due to an error.",
      "# ",
      "**Chainable**",
      "",
      "Chaining methods with this framework makes it easier to use and decrease size of large promises.",
      "# ", "# ",
      "# Documentation",
      "This module can be used on the `Server` and `Client`, we recommend placing it in ReplicatedStorage.",
      "[Read Documentation](/docs/frameworks/promise/)",
      "#### ", "#### ",
      "Here's a quick example using Promises.",
      "```",
      "local Promise = require('Promise')",
      "",
      "local myPromise = Promise.new(function(resolve, reject)",
      "    local success = true -- Replace with your operation's success condition",
      "    if success then",
      "        resolve('Operation succeeded!')",
      "    else",
      "        reject('Operation failed.')",
      "    end",
      "end)",
      "",
      "myPromise:Then(",
      "  function(value)",
      "      print('Success: ' .. value)",
      "  end,",
      "  function(reason)",
      "      print('Error: ' .. reason)",
      "  end",
      ")",
      "```",
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),
    
    logo : "/imgs/scripts/promiset1.jpg", 
    thumbnails : [
      "/imgs/scripts/promiset1.jpg"
    ],
    

    rating : 5,
    
    licenses : [
      {
        name : "Source-Code",
        type : "MIT License",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/LICENSE"
      }
    ],

    downloadcount : 24,
    source : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/promise.lua",
    downloads : [
      {
        name : "Lua",
        type : "Link",
        href : "/download/promise.lua"
      },
      {
        name : "GitHub",
        type : "File",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/promise.lua"
      },
    ],
    

    version : "1.0",
    created : "March 4 2025",
    updated : "March 4 2025",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/signal",
    category : "Script",
    engine : "Roblox",
    price : "FREE",


    name : "Signal",
    
    overview : [
      "**Signal**, a framework developed to `recreate BindableEvents` & `BindableFunctions` as one instance. Create script bindables using this framework for a much simpler and flexable framework.",
      "# ", "# ",
      "# Features",
      "**Combination of BindableEvent / BindableFunction**",
      "",
      "Use the exact same methods you'd normally find in a bindable events/functions.",
      "",
      "**Script Context**",
      "",
      "Signal stays the same RunContext and only accessable inside scripts unless made into a global variable.",
      "# ", "# ",
      "# Documentation",
      "This module can be used on the `Server` and `Client`, we recommend placing it in ReplicatedStorage.",
      "[Read Documentation](/docs/frameworks/signal/)",
      "#### ", "#### ",
      "Here's a quick example of using signal to create a built-in changed connection.",
      "```",
      "local Signal = require('path/to/signal')",
      "",
      "local Car = {",
      " Name = 'NormalCar'",
      " Changed = Signal.new();",
      "}",
      "",
      "Car.Changed:Connect(function(propertyName)",
      "  print(`${propertyName} was changed.`)",
      "end)",
      "",
      "Car.Name = 'RaceCar';",
      "Car.Changed:Fire('Name')",
      "```",
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),

    logo : "/imgs/scripts/signalt1.jpg", 
    thumbnails : [
      "/imgs/scripts/signalt1.jpg"
    ],
    

    rating : 5,
    
    licenses : [
      {
        name : "Source-Code",
        type : "MIT License",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/LICENSE"
      }
    ],

    downloadcount : 73,
    source : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/signal.lua",
    downloads : [
      {
        name : "Lua",
        type : "Link",
        href : "/download/signal.lua"
      },
      {
        name : "GitHub",
        type : "File",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/signal.lua"
      },
    ],
    

    version : "1.0",
    created : "March 4 2025",
    updated : "March 4 2025",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/axisindicator",
    category : "Plugin",
    engine : "Roblox",
    price : "FREE",

    name : "Axis Indicator",
    
    overview : [
      "**Axis Indicator** is a recreation of the view selector in Blender meant to replace the default ugly Roblox view selector. Easily identify the direction you're looking in whilst having full custommizability on the Gui through JSON styling.",
      "# ", "# ",
      "## Features",
      "**World Axis**",
      "",
      "Display the world axis based of your current orientation to determine your next course of action.",
      "## ",
      "**Axis View**",
      "",
      "Click on a axis to rotate your camera in that direction.",
      "## ",
      "**Customizability**",
      "",
      "Adjust the position by hovering and dragging the GUI by the white orb. Customize the colors through JSON file using the style plugin provided with Axis Indicator."
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/ai/logo.png", 
    thumbnails : [
      "/imgs/ai/t1.jpg"
    ],
    

    rating : 4.7,
    

    licenses : [
      {
        name : "Source-Code",
        type : "MIT License",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/LICENSE"
      }
    ],
    

    downloadcount : 853,
    source : "https://github.com/DonKingFrog/Axis-Indicator",
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/16120149836/Axis-Indicator"
      },

      {
        name : "RBXM",
        type : "File",
        href : "/download/AxisIndicator.rbxm"
      }
    ],
    

    version : "2.0.0",
    created : "Jan 26 2024",
    updated : "Feb 7 2024",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/exploitermayhem",
    category : "Admin Panel",
    engine : "Roblox",
    price : "FREE",

    name : "Exploiter Mayhem",
    
    overview : [
      "**Exploiter Mayhem** is a advanced admin panel designed for dealing with exploiters & events.",
      "## ",
      "Built-in media player for audio related events.",
      "## ",
      "Bunch of options to ruin an exploiter's experience in the server.",
      "# ", "# ",
      "## Features",
      "**Media Player**",
      "",
      "Use our built-in media player to play audio with adjustable volume, effects, timeline, and a playlist.",
      "## ",
      "**Global Chat**",
      "",
      "Talk to other administrators through the built-in global chat capable of sending text through different servers.",
      "## ",
      "**Exploiter Mayhem**",
      "",
      "If an exploiter is causing you yrouble, we give you a wide range of buyttons you can use on an exploiter to ruin their experiences such as crashing their PC!"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),

    contributors : [
      {
        name : "@mark80912",
        deed : "Testing prototypes and quality assurance."
      }
    ],

    requirements: [
      "API Services",
      "Third Party Teleports",
      "Third Party Sales"
    ],
    
    "discontinued": true,

    logo : "/imgs/em/logo.png", 
    thumbnails : [
      "/imgs/em/t1.png",
      "/imgs/em/t2.png",
      "/imgs/em/t3.png",
      "/imgs/em/t4.png"
    ],
    

    rating : 3.5,
    

    licenses : [
      {
        name : "Design",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      },
      {
        name : "Source-Code",
        type : "MIT License",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/LICENSE"
      }
    ],
    

    downloadcount : 621,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15489595904/Exploiter-Mayhem"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15489595904"
      }
    ],
    

    version : "1.0",
    created : "Feb 3 2023",
    updated : "May 1 2024",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/healthgui",
    category : "User Interface",
    engine : "Roblox",
    price : "FREE",

    name : "Health Gui",
    
    overview : [
      "**💙 Health Gui** is a redesign of the default Roblox health gui. Displaying if a user has VC, if their deceased, or and of course their health. Alter how the healthbar acts based of your properties in the config file.",
      "# ", "# ",
      "## Features",
      "**Animated Healthbar**",
      "",
      "Have a smooth transition between health changes in a moments notice between size and coloring.",
      "## ",
      "**Voice Chat**",
      "",
      "Have it show a mic icon above their head if the user has voice chat.",
      "## ",
      "**Death Icon**",
      "",
      "Display a skull icon upon death of a player.",
      "## ",
      "**Name Varients**",
      "",
      "Use DisplayName/Username/None which displays above the player's head."
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),

    contributors : [
      {
        name : "@mark80912",
        deed : "Testing prototypes and quality assurance."
      }
    ],
    

    logo : "/imgs/hg/logo.jpg", 
    thumbnails : [
      "/imgs/hg/t1.jpg"
    ],
    

    rating : 5,
    

    licenses : [
      {
        name : "Design",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      },
      {
        name : "Source-Code",
        type : "MIT License",
        href : "https://github.com/Dev-Equip/Luau-Frameworks/blob/main/LICENSE"
      }
    ],
    

    downloadcount : 385,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15490705273/HealthGui"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15490705273"
      }
    ],
    

    version : "1.0",
    created : "Nov 28, 2023",
    updated : "Nov 28, 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/ikcontroller",
    category : "Script",
    engine : "Roblox",
    price : "FREE",


    name : "IK Controller",
    
    overview : [
      "**Inverse Kinematics Controller** is a system designed to move the body or head of a player in the direction of the camera. Giving the realism that is character movement from the camera alone.",
      "## ",
      "Move the head so it looks in the direction where your camera is looking.",
      "## ",
      "Make the body move along with your head in the general direction your facing.",
      "# ", "# ",
      "## Features",
      "**Head Movement**",
      "",
      "Move the head into the direction your facing to let others know where you're looking.",
      "## ",
      "**Torso Movement**",
      "",
      "Move the torso into the direction your facing to let others know where your focusing on."
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),

    logo : "/imgs/ikc/logo.png", 
    thumbnails : [
      "/imgs/ikc/t1.jpg"
    ],
    

    rating : 5,
    

    downloadcount : 88,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15495010938/IKController"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15495010938"
      }
    ],
    

    version : "1.0",
    created : "Nov 29 2023",
    updated : "Nov 29 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/betterbaseplate",
    category : "Map",
    engine : "Roblox",
    price : "FREE",

    name : "Better Baseplate",
    
    overview : [
      "A map designed to replace the default baseplate template provided by Roblox.",
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),

    logo : "/imgs/maps/bblogo.jpg", 
    thumbnails : [
      "/imgs/maps/bbt1.jpg"
    ],
    

    rating : 5,
    

    downloadcount : 374,
    downloads : [
      {
        name : "RBXL",
        type : "Link",
        href : "/download/BetterBaseplate.rbxl"
      }
    ],
    

    version : "1.0",
    created : "Nov 30 2023",
    updated : "Nov 30 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/lowpolyisland",
    category : "Map",
    engine : "Roblox",
    price : "FREE",

    name : "Low Poly Island",

    overview : [
      "A map designed for low-poly island minigames or survival games.",
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),

    logo : "/imgs/maps/ipislogo.jpg", 
    thumbnails : [
      "/imgs/maps/ipist1.png"
    ],
    

    rating : 5,
    

    downloadcount : 836,
    downloads : [
      {
        name : "RBXL",
        type : "Link",
        href : "/download/LowPolyIsland.rbxl"
      }
    ],
    

    version : "1.0",
    created : "Nov 30 2023",
    updated : "Nov 30 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/scythe",
    category : "3D Model",
    engine : "Roblox",
    price : "FREE",

    name : "Scythe",
    
    overview : [
      "Modeled & Textured By DonKingFrog"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/models/slogo.jpg", 
    thumbnails : [
      "/imgs/models/st1.jpg"
    ],
    

    rating : 4,
    

    licenses : [
      {
        name : "Mesh & Texture",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      }
    ],
    

    downloadcount : 83,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15488458143/Scythe"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15488458143"
      }
    ],
    

    version : "1.0",
    created : "Nov 28 2023",
    updated : "Nov 28 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/bed",
    category : "3D Model",
    engine : "Roblox",
    price : "FREE",

    name : "Bed",
    
    overview : [
      "Modeled & Textured By DonKingFrog"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/models/blogo.jpg", 
    thumbnails : [
      "/imgs/models/bt1.jpg"
    ],
    

    rating : 5,
    

    licenses : [
      {
        name : "Mesh & Texture",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      }
    ],
    

    downloadcount : 148,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15495153644/Bed"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15495153644"
      }
    ],
    

    version : "1.0",
    created : "Nov 28 2023",
    updated : "Nov 28 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/bookshelf",
    category : "3D Model",
    engine : "Roblox",
    price : "FREE",

    name : "Bookshelf",
    
    overview : [
      "Modeled & Textured By DonKingFrog"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/models/booklogo.jpg", 
    thumbnails : [
      "/imgs/models/bookt1.jpg"
    ],
    

    rating : 5,
    

    licenses : [
      {
        name : "Mesh & Texture",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      }
    ],
    

    downloadcount : 45,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15495194948/Bookshelf"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15495194948"
      }
    ],
    

    version : "1.0",
    created : "Nov 28 2023",
    updated : "Nov 28 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/burgers",
    category : "3D Model",
    engine : "Roblox",
    price : "FREE",

    name : "Burgers",
    
    overview : [
      "Modeled & Textured By DonKingFrog"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/models/burlogo.jpg", 
    thumbnails : [
      "/imgs/models/burt1.jpg"
    ],
    

    rating : 5,
    

    licenses : [
      {
        name : "Mesh & Texture",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      }
    ],
    

    downloadcount : 67,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15495216916/Burgers"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15495216916"
      }
    ],
    

    version : "1.0",
    created : "Nov 28 2023",
    updated : "Nov 28 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/katana",
    category : "3D Model",
    engine : "Roblox",
    price : "FREE",

    name : "Katana",
    
    overview : [
      "Modeled & Textured By DonKingFrog"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/models/klogo.jpg", 
    thumbnails : [
      "/imgs/models/kt1.jpg"
    ],
    

    rating : 5,
    

    licenses : [
      {
        name : "Mesh & Texture",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      }
    ],
    

    downloadcount : 88,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15495228871/Katana"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15495228871"
      }
    ],
    

    version : "1.0",
    created : "Nov 29 2023",
    updated : "Nov 29 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/anvil",
    category : "3D Model",
    engine : "Roblox",
    price : "FREE",

    name : "Anvil",
    
    overview : [
      "Modeled & Textured By DonKingFrog"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/models/alogo.jpg", 
    thumbnails : [
      "/imgs/models/at1.png"
    ],
    

    rating : 5,
    

    licenses : [
      {
        name : "Mesh & Texture",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      }
    ],
    

    downloadcount : 482,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15495242999/Anvil"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15495242999"
      }
    ],
    

    version : "1.0",
    created : "Nov 29 2023",
    updated : "Nov 29 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/chesspieces",
    category : "3D Model",
    engine : "Roblox",
    price : "FREE",

    name : "Chess Pieces",
    
    overview : [
      "Modeled & Textured By DonKingFrog"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/models/chesslogo.jpg", 
    thumbnails : [
      "/imgs/models/chesst1.jpg"
    ],
    

    rating : 5,
    

    licenses : [
      {
        name : "Mesh & Texture",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      }
    ],
    

    downloadcount : 165,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15488312472/ChessPieces"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15488312472"
      }
    ],
    

    version : "1.0",
    created : "Nov 28 2023",
    updated : "Nov 28 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/glock",
    category : "3D Model",
    engine : "Roblox",
    price : "FREE",

    name : "Glock",
    
    overview : [
      "Modeled & Textured By DonKingFrog"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/models/glogo.jpg", 
    thumbnails : [
      "/imgs/models/gt1.jpg"
    ],
    

    rating : 5,
    

    licenses : [
      {
        name : "Mesh & Texture",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      }
    ],
    

    downloadcount : 861,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/15495404858/Glock"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=15495404858"
      }
    ],
    

    version : "1.0",
    created : "Nov 28 2023",
    updated : "Nov 28 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  },

  {
    
    redirect : "/product/shibaplushies",
    category : "3D Model",
    engine : "Roblox",
    price : "FREE",

    name : "Shiba Plushies",
    
    overview : [
      "Modeled & Textured By DonKingFrog"
    ].join("\n\n").replaceAll("```\n\n", "```\n").replaceAll("\n\n```", "\n```"),    

    logo : "/imgs/models/splogo.jpg", 
    thumbnails : [
      "/imgs/models/spt1.png"
    ],
    

    rating : 4.8,
    

    licenses : [
      {
        name : "Mesh & Texture",
        type : "CCBY-NC-ND",
        href : "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.en"
      }
    ],
    

    downloadcount : 2314,
    downloads : [
      {
        name : "Creator Store",
        type : "Link",
        href : "https://create.roblox.com/store/asset/115190049418656/Shiba-Plushies"
      },

      {
        name : "RBXM",
        type : "File",
        href : "https://assetdelivery.roblox.com/v1/asset/?id=115190049418656"
      }
    ],
    

    version : "2.0",
    created : "Nov 12 2022",
    updated : "Nov 28 2023",
    developer : "DonKingFrog",
    publisher : "Dev Equip",


    email : "info@devequip.com",
    website : {
      name : "www.devequip.com/contact",
      href : "https://devequip.com/contact"
    }
  }
]

